export default {
  overview: {
    label: 'Open overview',
    keys: ['o'],
    default: true,
    desc: 'Open overview of pages and projects'
  },
  edit: {
    label: 'Edit mode',
    keys: ['i'],
    default: false,
    desc: 'Show overview of pages in the current project'
  },
  preview: {
    label: 'Preview Mode',
    keys: ['p', 'tab'],
    default: true,
    desc: 'Toggle Page preview mode'
  },
  fullscreen: {
    label: 'Toggle fullscreen',
    keys: ['f'],
    default: false,
    desc: 'Toggle fullscreen'
  },
  showKeyboardShortcuts: {
    label: 'Show shortcuts',
    keys: ['0'],
    default: false,
    desc: 'Show this list of shortcuts'
  },
  showLayers: {
    label: 'Show layers',
    keys: ['super+y'],
    default: true,
    desc: 'Show layers panel'
  },
  closePageTab: {
    label: 'Close page tab',
    keys: ['w'],
    default: true,
    desc: 'Close the currently active page tab'
  },
  showDeveloper: {
    label: 'Show developer',
    keys: ['shift+u'],
    default: true,
    desc: 'Opens/focuses developer'
  }
};
